<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
  <path class="cls-1" d="m25.75,80.36c.53.53,1.39.54,1.93.01l6.63-6.53c1.13-1.13,1.47-2.79.97-4.24l1.43-1.38c.77-.74,1.78-1.15,2.85-1.15h18.18c3.22,0,6.27-1.24,8.58-3.49.1-.09-.72.87,12.4-14.81,1.95-2.3,1.66-5.76-.65-7.71-2.29-1.93-5.72-1.65-7.67.61l-8.07,8.29c-1.02-1.25-2.57-2.04-4.25-2.04h-15.25c-2.17-.91-4.47-1.37-6.85-1.37-6.58,0-12.33,3.04-15.42,8.74-1.3-.25-2.67.15-3.66,1.13l-6.5,6.52c-.53.53-.53,1.39,0,1.93l15.35,15.47Zm10.23-31.06c2.09,0,4.12.42,6.02,1.25.17.08.36.11.55.11h15.53c1.48,0,2.73,1.21,2.73,2.73s-1.23,2.73-2.73,2.73h-11.16c-.75,0-1.37.61-1.37,1.37s.61,1.37,1.37,1.37h11.16c3.02,0,5.47-2.45,5.47-5.47,0-.24-.02-.48-.05-.71,7.81-8.02,8.91-9.15,8.95-9.21.97-1.15,2.7-1.3,3.86-.33,1.15.97,1.3,2.7.32,3.86l-12.26,14.66c-1.79,1.72-4.14,2.67-6.63,2.67h-18.18c-1.78,0-3.47.68-4.75,1.92l-1.16,1.12-10.71-10.71c2.5-4.7,7.2-7.37,13.04-7.37Zm-17.14,9.07c.45-.45,1.14-.53,1.69-.19.24.14-.44-.47,11.84,11.79.55.55.52,1.42,0,1.93l-5.65,5.57-13.44-13.54,5.54-5.56Z"/>
  <path class="cls-2" d="m50.1,41.12c-8.79,0-15.94-7.15-15.94-15.94s7.15-15.94,15.94-15.94,15.94,7.15,15.94,15.94-7.15,15.94-15.94,15.94Zm0-29.2c-7.31,0-13.25,5.95-13.25,13.26s5.95,13.25,13.25,13.25,13.25-5.95,13.25-13.25-5.95-13.26-13.25-13.26Z"/>
  <path class="cls-3" d="m59.77,22.68l-3.67,3.58c-.26.24-.36.59-.31.94l.87,5.06c.15.86-.76,1.52-1.53,1.11l-4.55-2.38c-.3-.16-.67-.16-.98,0l-4.54,2.38c-.77.41-1.68-.25-1.53-1.11l.87-5.06c.06-.35-.05-.7-.3-.94l-3.67-3.58c-.63-.61-.28-1.68.59-1.8l5.07-.73c.35-.05.64-.27.8-.58l2.27-4.6c.39-.78,1.5-.78,1.89,0l2.27,4.6c.15.31.45.53.8.58l5.07.73c.87.12,1.21,1.19.59,1.8Z"/>
</svg>
</template>

<script>
export default {
    name: "BrandPerformanceByCustomerIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #115c72;
  }
  .cls-2 {
    fill: #59c5c7;
  }
  .cls-3 {
    fill: #bce2d2;
  }
</style>